// src/hooks/useMediaQuery.ts — SCE Issues
// Évalue une media query en JavaScript, avec suivi des changements.
//
// ─── Pourquoi en JS et pas en CSS ───
//
// Le basculement page/modale n'est pas qu'une affaire d'apparence : sous 768px
// on ne doit PAS monter la liste derrière la fiche (deux pages rendues
// simultanément, deux jeux de requêtes). Il faut donc décider côté React, pas
// seulement masquer en CSS.
//
// `useSyncExternalStore` plutôt qu'un useState + useEffect : pas de rendu
// intermédiaire à la mauvaise valeur au premier montage, et l'abonnement est
// géré par React.

import { useCallback, useSyncExternalStore } from 'react'

/** Point de rupture bureau — aligné sur globals.css et sur Audit5S. */
export const BUREAU = '(min-width: 768px)'

export function useMediaQuery(query: string): boolean {
  const souscrire = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    [query],
  )

  const lire = useCallback(() => window.matchMedia(query).matches, [query])

  // Snapshot serveur : false. L'app est 100 % client (SPA), ce cas ne se
  // produit pas, mais useSyncExternalStore exige l'argument.
  return useSyncExternalStore(souscrire, lire, () => false)
}

/** Raccourci : vrai à partir du point de rupture bureau. */
export function useEstBureau(): boolean {
  return useMediaQuery(BUREAU)
}
